import { render, staticRenderFns } from "./ContactsClicks.vue?vue&type=template&id=75ac0bc2&scoped=true"
import script from "./ContactsClicks.vue?vue&type=script&lang=js"
export * from "./ContactsClicks.vue?vue&type=script&lang=js"
import style0 from "./ContactsClicks.vue?vue&type=style&index=0&id=75ac0bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac0bc2",
  null
  
)

export default component.exports